export const COMPONENT_NAME = 'PrivacyPolicy';
